import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { style: {"line-height":"40px"} }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Input, {
          height: "29px",
          width: '130px',
          placeholder: "請輸入驗證碼",
          modelValue: _ctx.captchaCodeRef,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.captchaCodeRef) = $event)),
          inputType: 'number'
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("img", {
        class: "cursor-pointer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('getCaptchaImage'))),
        src: _ctx.previewLogo.src
      }, null, 8, _hoisted_4),
      _hoisted_5
    ])
  ]))
}